<template>
  <div v-if="id">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <DataTable
                :id="id"
                ref="datatableEchange"
                @onSelect="onSelectRows"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../components/DataTable.vue';
import names from '@/constants/routes/chantier/planning';

export default {
  data() {
    return {
      isSelectEchange: false,
      id: null,
      routes: names,
    };
  },
  components: {
    DataTable,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    onSelectRows(isSelectEchange) {
      this.isSelectEchange = isSelectEchange;
    },
    isEditRoute() {
      return /.*edit.*/i.test(this.$route.name);
    },

    init() {
      this.id = Number(this.$route.params.id);
    },
  },

  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
